module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-08.c8ae2c0d.png";